import maxLogo from "../../../assets/max-messenger-sign-logo.svg";
import emailIcon from "../../../assets/email.svg";

export const LAYOUT_CONFIG = {
  intermark: {
    href: "https://max.ru/u/f9LHodD0cOKQVeF_LGxTS-TTUKn___I7ZMbhayASBghbJUBSy7E_qIkFbQc",
    icon: maxLogo,
    alt: "MAX",
  },
  shermont: {
    href: "mailto:m.pekin@ugmkstroy.ru?subject=Отзыв%20о%20работе%20личного%20кабинета",
    icon: emailIcon,
    alt: "Email",
  },
};